import React from "react";
import {profileImageUrl, ventureImageUrl} from "../../../helpers/urls";

const CategoryOptionLabel = (category) => <>{category.name}</>
export default CategoryOptionLabel;
